var _linearGradient, _linearGradient2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 711,
    viewBox: "0 0 711 711",
    width: 711,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: ".246254%",
    x2: "99.753746%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a0c2e"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ab55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08660d"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.558905 104.877806 409.623445-.604188c22.091366-.032585 40.026372 17.849591 40.058956 39.940957.000058.039284.000058.078568 0 .117853l-.604521 410.863305c-.02619 17.800295-1.884227 24.253006-5.367609 30.759207s-8.58997 11.612808-15.096158 15.096213c-6.506189 3.483406-12.958893 5.341466-30.759188 5.367721l-409.623445.604189c-22.091366.032584-40.026371-17.849591-40.058956-39.940957-.000057-.039284-.000058-.078569 0-.117853l.604521-410.863305c.026191-17.800296 1.884228-24.253006 5.367609-30.759207 3.483382-6.506202 8.58997-11.612808 15.096159-15.096214 6.506188-3.483405 12.958892-5.341466 30.759187-5.367721z",
    fill: "url(#a)",
    opacity: 0.48,
    transform: "matrix(.42261826 .90630779 -.90630779 .42261826 528.155579 -117.741515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.138153 104.932583 410.246946-.788936c22.091349-.042484 40.034365 17.831654 40.076849 39.923003.000098.051282.000098.102564 0 .153846l-.788937 410.246946c-.034213 17.791104-1.892729 24.239836-5.37528 30.742268-3.482552 6.502431-8.586348 11.606227-15.08878 15.088779-6.502431 3.482552-12.951163 5.341067-30.742268 5.375281l-410.246946.788936c-22.091349.042484-40.034365-17.831654-40.076849-39.923003-.000098-.051282-.000098-.102564 0-.153846l.788937-410.246946c.034213-17.791105 1.892728-24.239836 5.37528-30.742268 3.482552-6.502431 8.586348-11.606227 15.08878-15.088779 6.502431-3.482552 12.951163-5.341067 30.742268-5.375281z",
    fill: "url(#b)",
    opacity: 0.48,
    transform: "matrix(.70710678 .70710678 -.70710678 .70710678 355.302954 -147.170858)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.88f1aeca383b23f9d0a17f1ad0b56a77.svg";
export { ForwardRef as ReactComponent };